var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.13086,
    height: 118.506,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 118.506,
    opacity: 0,
    width: 9.13086,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58984 118.506C7.08008 118.506 9.13086 116.553 9.13086 114.014L9.13086 4.54102C9.13086 2.05078 7.08008 0.0976562 4.58984 0.0976562C2.05078 0.0976562 0 2.05078 0 4.54102L0 114.014C0 116.553 2.05078 118.506 4.58984 118.506Z",
    fill: "#c9bab6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.7dd6535fac46e659b917db4e581bf1dc.svg";
export { ForwardRef as ReactComponent };